import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "Comment fonctionne le convoyage avec Carvaelis ?",
        a: "Vous renseignez votre trajet et votre véhicule sur la plateforme, recevez un devis instantané, puis un convoyeur certifié prend en charge votre voiture au point de départ. Le véhicule est suivi par GPS jusqu'à la livraison.",
    },
    {
        q: "Mon véhicule est-il assuré pendant le transport ?",
        a: "Oui. Tous les véhicules convoyés via Carvaelis bénéficient d'une assurance tous risques pendant la totalité du trajet, sans franchise cachée.",
    },
    {
        q: "Comment sont sélectionnés les convoyeurs ?",
        a: "Nos convoyeurs sont rigoureusement vérifiés : permis, expérience de conduite, casier judiciaire, références et entretien individuel. Seuls les profils certifiés peuvent prendre en charge des missions.",
    },
    {
        q: "Combien coûte un convoyage ?",
        a: "Le tarif dépend de la distance, du type de véhicule et de la date. Vous obtenez un devis instantané et transparent directement sur la plateforme, sans frais cachés.",
    },
    {
        q: "Comment devenir convoyeur Carvaelis ?",
        a: "Rendez-vous dans l'espace convoyeur de la plateforme pour vous inscrire. Vous serez accompagné dans la constitution de votre dossier et la validation de votre profil avant de recevoir vos premières missions.",
    },
    {
        q: "Dans quelles zones intervient Carvaelis ?",
        a: "Nous couvrons l'ensemble du territoire français métropolitain. Pour les trajets internationaux, contactez notre équipe dédiée.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq-section"
            data-testid="faq-section"
            className="section-y bg-white border-y border-slate-200"
        >
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                            — Questions fréquentes
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-ink text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                            Des questions ?
                            <br />
                            Des réponses.
                        </h2>
                        <p className="mt-6 text-slate-600 text-lg">
                            Tout ce que vous devez savoir avant de
                            convoyer ou d'être convoyeur sur Carvaelis.
                        </p>
                    </div>

                    <div className="lg:col-span-7 lg:col-start-6">
                        <Accordion
                            type="single"
                            collapsible
                            className="w-full"
                            defaultValue="item-0"
                        >
                            {FAQS.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border-b border-slate-200 py-2"
                                >
                                    <AccordionTrigger className="text-left font-display font-bold text-lg sm:text-xl text-ink hover:no-underline py-6 hover:text-signal transition-colors">
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-base text-slate-600 leading-relaxed pb-6">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
